import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

const scrollWithOffset = (element) => {
  const navbarOffset = window.innerHeight * 0.1;
  const elementPosition =
    element.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({
    top: elementPosition - navbarOffset,
    behavior: "smooth"
  });
};

const useScrollToElement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToElement = (route, elementId) => {
    const currentPath = location.pathname;

    if (currentPath === route) {
      const element = document.getElementById(elementId);
      if (element) {
        scrollWithOffset(element);
      }
    } else {
      navigate(`${route}#${elementId}`);
    }
  };

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        scrollWithOffset(element);
      }
    }
  }, [location]);

  return scrollToElement;
};

export default useScrollToElement;
